import Layout from "@/components/Layout";
import { Container, VStack } from "@chakra-ui/react";
import Header from "components/Header";
import HeadingTitle from "components/HeadingTitle";
import Text from "components/shared/typography/Text";
import { contentTag } from "utils/constants";
import {fetchPageContent} from "utils/fetchApi";

const Privacy = ({ content }) => {
  return (
    <Layout>
      <Header browserTitle="WellFitly - Privacy Policy" />
      <Container maxW={"7xl"} p="12" minH={"70vh"}>
        <VStack paddingTop="10px" spacing="2" alignItems="flex-start">
          <HeadingTitle mainTitle={content.main_title} />
          <Text content={content.content} />
        </VStack>
      </Container>
    </Layout>
  );
};

export default Privacy;

export const getStaticProps = async () => {
  const content = await fetchPageContent({
    tag: contentTag.privacyPolicyPage,
  });
  return {
    props: {
      content,
    },
  };
};
